export function round(input, places = 2) {
    return +(Math.round(input + 'e+' + places) + 'e-' + places);
}